export default "__VITE_ASSET__By_Z3YEg__"